<style scoped>
.title-header {
  padding-top: 1rem !important;
  line-height: 24px !important;
  padding-bottom: 14px;
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.profile-switcher.components-container >>> .profile-tabs .card-header {
    background-color: #f0f1f2;
}

/* overriding bootstrap css class for switcher */
>>> .custom-switch .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #adb5bd;
}
</style>

<template>
  <b-row>
    <b-col class="profile-switcher components-container">
      <b-row>
        <b-col >
          <div class="title-header bg-anchor ada-text-style" >
            <b-row>
              <b-col offset="7">
                <div class="float-right mr-4 switch-container">
                  Missing Docs
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <top-missing-documents
            @missingDocumentsCount="missingDocumentsCount = $event"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import Badge from '@/components/utils/Badge';
import TopMissingDocuments from '@/components/profile/sections/tabs/top_missing_documents/TopMissingDocuments';

export default {
  name: 'ProfilePageSwitcher',
  components: {
    TopMissingDocuments,
    Badge,
  },
  data() {
    return {
      showTopMissingDocs: false,
      missingDocumentsCount: 0,
    };
  },
  computed: {
    loanAppDoc() {
      return this.$store.getters.documents.find(doc => doc.type === 'Loan App') || { approvedCount: 0 };
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.loanAppDoc.approvedCount) {
        this.showTopMissingDocs = true;
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/ProfilePageSwitcher.vue